// extracted by mini-css-extract-plugin
export var content = "question-description-module--content--80928";
export var descriptionTitle = "question-description-module--description-title--fa58a";
export var displayContent = "question-description-module--display-content--15013";
export var productDiscription = "question-description-module--product-discription--27f05";
export var productIcon = "question-description-module--product-icon--0ae7e";